import { required, SelectInput } from "react-admin";

export const projectCodeList = [
  { id: "SCH-ADH", name: "SCH-ADH" },
  { id: "SCH-CCA", name: "SCH-CCA" },
  { id: "SCH-FIX", name: "SCH-FIX" },
];

const ProjectCodeInput = () => {
  return (
    <SelectInput
      source="projectCode"
      choices={projectCodeList}
      validate={required()}
    />
  );
};

export default ProjectCodeInput;
